export default {
    getAppointments: state => state.appointments,
    getCurrentAppointment: state => state.currentAppointment,
    getAppoinmentsFilter: state => state.filter,
    getCurrentDoctor: state => state.currentDoctor,
}